import { DATA_STORE_MAIN, DATA_STORE_JOB, FILTER_STORE, SET_RESULT_COUNT } from './types';

export const storeMainData = (payload) => ({ type: DATA_STORE_MAIN, payload });

export const storeJob = (payload) => ({ type: DATA_STORE_JOB, payload });

export const storeFilters = (payload) => ({ type: FILTER_STORE, payload });

export const storeResultCount = (count) => ({ type: SET_RESULT_COUNT, count });
